import React from 'react';
import { DocumentStatus } from 'types/documentsService';
import { TagStyled } from './styles';

interface Props {
  status: DocumentStatus;
}

export const STATUS_TEXT_MAP = Object.freeze({
  [DocumentStatus.BYPASSED]: 'Bypassed',
  [DocumentStatus.INACTIVE]: 'Inactive',
  [DocumentStatus.NOT_UPLOADED]: 'Not Uploaded',
  [DocumentStatus.UPLOADED]: 'Uploaded',
  [DocumentStatus.APPROVED]: 'Approved',
  [DocumentStatus.REJECTED]: 'Rejected',
  [DocumentStatus.SIGNATURE_PENDING]: 'Signature pending',
  [DocumentStatus.SIGNATURE_REQUEST_FAILED]: 'Signature failed',
  [DocumentStatus.SIGNED]: 'Signed',
});

const DocumentTag: React.FC<Props> = ({ status }) => {
  return <TagStyled $status={status}>{STATUS_TEXT_MAP[status]}</TagStyled>;
};

export default DocumentTag;
